import React, { createRef } from 'react';
import './styles/index.scss';
type NoteFrameProps = {
  iframeNote: CMxAPI.HtmlDoc;
};

const preventCheckboxDefault = (e: Event) => e.preventDefault();

class NoteFrame extends React.Component<NoteFrameProps> {
  _iframeRef: React.RefObject<HTMLIFrameElement | null>;

  constructor(props: NoteFrameProps) {
    super(props);
    this._iframeRef = createRef();
  }

  componentDidMount() {
    this.updateIframeContent();
  }

  componentDidUpdate(prevProps: NoteFrameProps) {
    if (this.props.iframeNote.id !== prevProps.iframeNote.id) {
      this.updateIframeContent();
    }
  }

  updateIframeContent() {
    const { iframeNote } = this.props;
    const iframe = this._iframeRef.current;
    if (!iframe) return;

    const iframeDocument = iframe.contentWindow.document;

    iframeDocument.open();
    iframeDocument.write(iframeNote.content);
    iframeDocument.close();

    // Prevent inner scrollbars
    iframeDocument.body.style.overflowY = 'hidden';
    iframeDocument.body.style.margin = '0'; // Ensure no margin offset

    // CDMX-15489: LibreOffice-generated HTML from the document converter emits
    // inline line-height values on some elements that cause text lines to collapse
    // and overlap. Reset any inline line-height to normal until the converter is fixed.
    iframeDocument
      .querySelectorAll<HTMLElement>('[style*="line-height"]')
      .forEach(el => {
        el.style.lineHeight = 'normal';
      });

    // --- Dynamic Resizing Logic ---
    // We use requestAnimationFrame to ensure the browser has 
    // rendered the written content before we measure it.
    requestAnimationFrame(() => {
      const height = iframeDocument.documentElement.scrollHeight;
      iframe.style.height = `${height}px`;
    });
    // ------------------------------

    const inputEls = iframeDocument.getElementsByTagName('input');
    for (let i = 0; i < inputEls.length; i++) {
      const input = inputEls[i];
      if (input.type === 'checkbox') {
        // Use a named function reference so duplicate add calls are no-ops
        // (the browser deduplicates identical listener + type + capture triples).
        input.addEventListener('click', preventCheckboxDefault);
      }
    }
  }

  render() {
    return (
      <iframe
        className="note-iframe autosize-iframe-content"
        sandbox="allow-same-origin"
        ref={this._iframeRef}
      />
    );
  }
}

export { NoteFrame };
